var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function ConditionalNav(el) {
  var $nav = $(el),
      $toggle = $nav.find('[data-dropdown-menu]');

  $toggle.on('click', function(e) {
    e.preventDefault();
    $nav.toggleClass('js-menu-open');

    ariaExpanded = ($toggle.attr("aria-expanded") === "true") ? "false" : "true";
    $toggle.attr("aria-expanded", ariaExpanded);
  });
}

module.exports = ConditionalNav;
